// Pathify
import {make} from 'vuex-pathify'
import api from "@/services/api";
import {toast} from '@/util/helpers';
import Models from "../../models";

// Data
const state = {
	infographics:[],
	infographic: Models.Resource('Infographic'),
}

const getters = make.getters(state)

const mutations = make.mutations(state)

const actions = {
	...make.actions(state),
	getInfographics: ({ dispatch }) => {
		api.infographics.index()
			.then(response => dispatch('setInfographics', response.data))
			.catch(error => toast.add(error.message, 'error'))
	},
	getInfographic: ({ dispatch }, id) => {
		api.infographics.show(id)
			.then(response => dispatch('setInfographic', response.data))
			.catch(error => toast.add(error.message, 'error'))
	}

}

export default {
	namespaced: true,
	state,
	mutations,
	actions,
	getters,
}
